































































import { faExpandAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { Title },
  props: {
    classifiedViewWidth: { type: Number, required: true },
    classified: { type: Object, default: null }
  },
  setup() {
    return {
      faExpandAlt,
      faTimes
    }
  }
})
